import React, { useCallback, useContext } from 'react'
import AuthContext from '../../context/AuthContext'
import { Button } from '../../@/components/ui/button'
import { useRouter } from 'next/navigation'
import useCompanySubscription from '../../hooks/queries/useCompanySubscription'

const TrialAlert = () => {
	const authContext = useContext(AuthContext)
	const router = useRouter()
	const { companySubscription, isTrialUsed, isLoading: subscriptionLoading } = useCompanySubscription()

	const onStartTrialPress = useCallback(() => {
		router.push('/dashboard/billing?highlight=trial')
	}, [router])

	// Check if we should show the trial alert
	const shouldShowTrialAlert =
		!authContext.loading &&
		!subscriptionLoading &&
		authContext.user &&
		!isTrialUsed &&
		authContext.isCompanyManager &&
		!companySubscription

	if (!shouldShowTrialAlert) {
		return null
	}

	return (
		<div className="p-4 mb-4 text-sm text-start text-white bg-hitemup-green rounded-lg relative" role="alert">
			<div className="flex items-center justify-between">
				<div className="flex-1">
					<p className="font-semibold">🎉 You&apos;re eligible for a free 7-day trial!</p>
					<p className="mt-1 opacity-90">
						Unlock all premium features and experience the full power of Hit Em Up dashboard.
					</p>
				</div>
			</div>
			<div className="flex mt-3">
				<Button variant="secondary" onClick={onStartTrialPress}>
					Start Free Trial
				</Button>
			</div>
		</div>
	)
}

export default TrialAlert
